@import "~@govbr-ds/core/src/components/tab/tab";

:host {
  display: block;
}

.br-tab {
  box-sizing: border-box;
  width: 100%;
  overflow-x: hidden;
  padding: var(--tab-container-padding, 16px);
}

.tab-nav {
  &[data-counter="true"] {
    min-height: 102px;
    overflow: hidden;

    ul {
      max-height: 65px;
    }
  }

  .tab-item {
    button {
      .icon:not(:only-child) {
        margin-right: var(--spacing-scale-base);
      }
    }
  }
}

.results {
  display: flex;
  font-weight: var(--font-weight);
  justify-content: center;
  margin-top: var(--spacing-scale-2x);
  position: absolute;
  top: 100%;
}
